var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1484,
    cy: 12,
    r: 12,
    fill: "#55B653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6183 12.412C19.6285 11.974 19.3906 11.5738 18.9998 11.3663L9.89194 6.52239C9.48406 6.2991 9.00026 6.33171 8.61114 6.59421C8.21489 6.86114 8.00711 7.48943 8.11257 7.94073L8.93201 11.4439C9.01614 11.8032 9.34229 12.0535 9.72048 12.0483L14.8168 11.9833C15.0779 11.9756 15.2874 12.1811 15.2796 12.437C15.2763 12.6885 15.0657 12.8949 14.8046 12.9026L9.70347 12.9637C9.32529 12.9681 8.9924 13.226 8.89872 13.5875L7.97798 17.1216C7.8663 17.5392 7.98463 17.9539 8.28149 18.245C8.31642 18.2792 8.35571 18.3177 8.39511 18.3476C8.78044 18.6375 9.28859 18.67 9.72505 18.439L18.9631 13.4653C19.3595 13.2564 19.6081 12.85 19.6183 12.412Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSend);
export default __webpack_public_path__ + "static/media/messageSend.2878b48b13f911c41759edfcda97a3c8.svg";
export { ForwardRef as ReactComponent };